import { useLocation } from "react-router-dom";

const BuyHeader = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const sale_type = params.get("sale_type");
  const category = params.get("category");
  const open_house = params.get("open_house") || "false";

  // Convert slug to readable text
  const formatText = (text) =>
    text
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const saleTypeTextMap = {
    standard: "Homes For Sale",
    foreclosure: "Foreclosures",
    fsbo: "For Sale by Owner",
    new_construction: "New Construction",
    coming_soon: "Coming Soon",
    recent_sale: "Recent Sales"
  };

  let headingText = "Homes For Sale";

  // Category takes precedence
  if (category) {
    headingText = formatText(category)+"s For Sale";
  } else if (sale_type && saleTypeTextMap[sale_type]) {
    headingText = saleTypeTextMap[sale_type];
  }

  if (open_house === "true") {
    headingText += " - Open House";
  }

  return <h6 className="mb-0">{headingText}</h6>;
};

export default BuyHeader;
